import { useState, useMemo } from 'react'
import { diasRestantes, claseSemaforo, estadoTexto, formatFecha } from '../data/fechas2026'
import styles from '../CalendarioTributario.module.css'

const OBLIGACIONES = ["todas","IVA","Retención","Renta","RUB","Planilla","ICA-BOG","ReteICA-BOG","Exógena"]
const ESTADOS = ["todos","r","a","v","g"]

function tagColor(tag) {
    if (tag === 'dian') return styles.tagDian
    if (tag === 'bog')  return styles.tagBog
    return styles.tagPla
}
function tagLabel(tag) {
    if (tag === 'dian') return 'DIAN'
    if (tag === 'bog')  return 'S.H.BOG'
    return 'MI PLANILLA'
}

export default function SemaforoTabla({ datos }) {
    const [filtroOblig, setFiltroOblig] = useState('todas')
    const [filtroEstado, setFiltroEstado] = useState('todos')

    const filas = useMemo(() => {
        let arr = datos.map(v => {
            const d = diasRestantes(v.f)
            return { ...v, d, cl: claseSemaforo(d, v.f) }
        })
        if (filtroOblig !== 'todas')  arr = arr.filter(v => v.cat === filtroOblig)
        if (filtroEstado !== 'todos') arr = arr.filter(v => v.cl === filtroEstado)
        arr.sort((a,b) => {
            if (a.d === null && b.d === null) return 0
            if (a.d === null) return 1
            if (b.d === null) return -1
            return a.d - b.d
        })
        return arr
    }, [datos, filtroOblig, filtroEstado])

    // Resumen
    const cuenta = c => datos.map(v => {const d=diasRestantes(v.f);return claseSemaforo(d,v.f)}).filter(cl=>cl===c).length
    const tot=datos.length, cr=cuenta('r'), ca=cuenta('a'), cv=cuenta('v')

    if (!datos.length) return null

    return (
        <>
            {/* Leyenda */}
            <div className={styles.leyenda}>
                <span className={`${styles.leg} ${styles.legV}`}>🟢 Al día (más de 15 días)</span>
                <span className={`${styles.leg} ${styles.legA}`}>🟡 Próximo (1 a 15 días)</span>
                <span className={`${styles.leg} ${styles.legR}`}>🔴 Vencido</span>
                <span className={`${styles.leg} ${styles.legG}`}>⬜ Fecha por confirmar</span>
            </div>

            {/* Resumen cards */}
            <div className={styles.resumen}>
                <div className={`${styles.sc} ${styles.scT}`}><span className={styles.scN}>{tot}</span><span className={styles.scL}>Total</span></div>
                <div className={`${styles.sc} ${styles.scR}`}><span className={styles.scN}>{cr}</span><span className={styles.scL}>🔴 Vencidas</span></div>
                <div className={`${styles.sc} ${styles.scA}`}><span className={styles.scN}>{ca}</span><span className={styles.scL}>🟡 Próximas</span></div>
                <div className={`${styles.sc} ${styles.scV}`}><span className={styles.scN}>{cv}</span><span className={styles.scL}>🟢 Al día</span></div>
            </div>

            {/* Filtros */}
            <div className={styles.filtros}>
                <label>Obligación:</label>
                <select value={filtroOblig} onChange={e=>setFiltroOblig(e.target.value)} className={styles.filtroSelect}>
                    <option value="todas">Todas</option>
                    <option value="IVA">IVA (DIAN)</option>
                    <option value="Retención">Retención Fuente</option>
                    <option value="Renta">Renta Jurídicas</option>
                    <option value="RUB">Benef. Finales RUB</option>
                    <option value="Planilla">Mi Planilla</option>
                    <option value="ICA-BOG">ICA Bogotá</option>
                    <option value="ReteICA-BOG">ReteICA Bogotá</option>
                    <option value="Exógena">Exógena</option>
                </select>
                <label>Estado:</label>
                <select value={filtroEstado} onChange={e=>setFiltroEstado(e.target.value)} className={styles.filtroSelect}>
                    <option value="todos">Todos</option>
                    <option value="r">🔴 Vencido</option>
                    <option value="a">🟡 Próximo</option>
                    <option value="v">🟢 Al día</option>
                    <option value="g">⬜ Sin fecha</option>
                </select>
            </div>

            {/* Tabla */}
            <div className={styles.tableCont}>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Entidad</th>
                                <th>Obligación</th>
                                <th>Período / Detalle</th>
                                <th>Fecha Límite</th>
                                <th>Días</th>
                                <th>Estado</th>
                                <th>Norma</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filas.map((v,i) => (
                                <tr key={i} className={styles[`row${v.cl.toUpperCase()}`]}>
                                    <td>
                                        <span className={`${styles.tag} ${tagColor(v.tag)}`}>{tagLabel(v.tag)}</span>
                                        <strong style={{fontSize:'11px'}}>{v.ent}</strong>
                                    </td>
                                    <td><strong>{v.ob}</strong></td>
                                    <td className={styles.tdPer}>{v.per}</td>
                                    <td className={styles.tdFecha}>{formatFecha(v.f)}</td>
                                    <td className={styles.tdDias}>{v.d !== null ? v.d+'d' : 'N/D'}</td>
                                    <td><span className={`${styles.pill} ${styles[`pill${v.cl.toUpperCase()}`]}`}>{estadoTexto(v.cl,v.d)}</span></td>
                                    <td className={styles.tdNorma}>{v.norma}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filas.length === 0 && (
                        <div className={styles.sinRes}>
                            <div className={styles.sinResIcon}>😕</div>
                            Sin resultados para los filtros aplicados.
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
